<template>
    <div class="row">
        <div class="col-sm-6 col-md-6">
            <Card>
                <div class="card-list-heading">
                    <h5 class="text-bold">{{ __('Settings') }}</h5>
                </div>

                <div class="row">
                    <div class="col-sm-12 col-md-12">
                        <div class="form-row-flex">
                            <span>
                                {{ __('Full name') }}
                            </span>
                            <FormInput
                                name="title"
                                type="text"
                                v-model="user.title"
                                v-validate="'required'"
                            ></FormInput>
                        </div>

                        <div class="form-row-flex">
                            <span>
                                {{ __('Role') }}
                            </span>
                            <FormInput
                                name="role"
                                type="text"
                                v-model="user.role"
                                v-validate="'required'"
                            ></FormInput>
                        </div>

                        <div class="form-row-flex">
                            <span>
                                {{ __('Email') }}
                            </span>
                            <FormInput
                                :value="user.email"
                                disabled
                                name="email"
                                type="email"
                            ></FormInput>
                        </div>

                        <div class="form-row-flex">
                            <span>
                                {{ __('Phone') }}
                            </span>
                            <FormInput
                                name="phone"
                                type="text"
                                v-model="user.phone"
                                v-validate="{ required: true, regex: /^[0-9\s\+]*$/ }"
                            >
                                <template slot="prepend">
                                  <!--  <div class="input-group-prepend">
                                        <span class="input-group-text">+370</span>
                                        </div>-->
                                </template>
                            </FormInput>
                        </div>

                        <div class="form-row-flex">
                            <span>
                                {{ __('Company name') }}
                            </span>
                            <FormInput
                                :value="user.company"
                                disabled
                                name="company"
                                type="text"
                            ></FormInput>
                        </div>

                        <div class="form-row-flex">
                            <span>
                                {{ __('Company code') }}
                            </span>
                            <FormInput
                                :value="user.companyCode"
                                disabled
                                name="company_code"
                                type="text"
                            ></FormInput>
                        </div>

                        <RequestButton
                            :on-click="saveUser"
                            class="btn btn-md btn-primary float-right"
                        >
                            {{ __('Save') }}
                        </RequestButton>
                    </div>

                
                </div>
            </Card>
        </div>
         <div class="col-sm-6 col-md-6">
            <Card>
                <div class="card-list-heading">
                    <h5 class="text-bold">{{ __('Password') }}</h5>
                </div>

                <div class="row">
               
                   

                    <ProfilePasswordChange class="col-sm-12 col-md-12" />
                </div>
            </Card>
        </div>
    </div>
</template>

<script>
import { __ } from '../../translations/localization'
import ProfilePasswordChange from './ProfilePasswordChange'

export default {
  name: 'ProfileEditForm',

  components: { ProfilePasswordChange },

  data () {
    return {
      user: {
        title: this.$auth.user().title,
        role: this.$auth.user().role,
        email: this.$auth.user().email,
        phone: this.$auth.user().phone,
        companyCode: this.$auth.user().companyCode,
        company: this.$auth.user().company
      }
    }
  },

  methods: {
    saveUser () {
      return this.$validator.validate().then((valid) => {
        if (valid) {
           return this.$api.auth.updateProfile(this.user)
            .then(() => {
              this.$auth.fetch().then((res) => {
                this.$auth.user(res.data.data)
                this.$toaster.success(__('Profile successfully updated!'))
              })
            }).catch((response) => {
            this.setErrorsFromResponse(response)
          })
        }
      })
    }
  }
}
</script>
